import * as catalogProductViewObjectExecutor from './executors/ProductViewExecutor.js';

/**
 * Просто реестр всех исполниелей маркетинговых событий по PageId:Executor
 * @param {string} pageId - Идентификатор страницы.
 * смотри обязательно app/common/enums/common/ActivePageIdentifierEnum.php
 * каждый executor должен экспортировать функцию run() в обязательном порядке.
 * TODO[needImpl] - вынести PageId в enum
 */
export const executorsRegistry = {
    /* TODO[justMvp] PageId пока просто числами. */
    5: catalogProductViewObjectExecutor,
    0: {
        run: () => {
            //дефолтный исполнитель для всех страниц. Общий. Можно дополнить
        }
    }
}